import React, { Component } from "react";
import { EditHeadComponent } from "./../BioAndSubEditComponent";
import { connect } from "react-redux";
import { Col, Button, Image, Modal, Row } from "react-bootstrap";
import CommonDropdown from "./../../../components/commonDropdown";
import InputComp from "./../../../components/InputFieldComponent";
import messageImg from "./../../../assets/icons/envelope-gray.png";
import { TutorSettingAction } from "./../../../redux/actions";
import { updateTutorSettings } from "../../../apis/tutors";

class ModeofTutorSetting extends Component {
  constructor() {
    super();
    this.state = {
      editMode: "",
      selectMyaddress: "",
      addAddress: {},
      selectedIndex: "",
      addressRaw: "",
      address: {},
      canTeachOnline: "",
      canTeachInperson: "",
      willignessToTravel: "2 miles",
    };
  }

  componentDidMount = () => {
    const { tutorSettingData } = this.props;
    let addressRaw = tutorSettingData?.tutorDetails?.addressRaw
      ? tutorSettingData.tutorDetails.addressRaw
      : "";
    let address = tutorSettingData?.address ? tutorSettingData.address : {};
    let canTeachOnline =
      tutorSettingData?.tutorDetails?.canTeachOnline !== ""
        ? tutorSettingData?.tutorDetails?.canTeachOnline
        : "";
    let tempValCanTeachOnline = canTeachOnline;
    
    let canTeachInperson =
    tutorSettingData?.tutorDetails?.canTeachInperson !== ""
    ? tutorSettingData?.tutorDetails?.canTeachInperson
    : "";
    let tempValCanTeachInperson = canTeachInperson;
    let modeOfTeaching =
      tutorSettingData?.tutorDetails?.modeOfTeaching !== ""
        ? tutorSettingData?.tutorDetails?.modeOfTeaching
        : "";

    this.setState({
      addressRaw,
      address,
      canTeachOnline,
      canTeachInperson,
      modeOfTeaching,
      tempValCanTeachOnline,
      tempValCanTeachInperson,
    });
  };

  componentDidUpdate = (prevProps) => {
    const { tutorSettingData } = this.props;

    if (
      JSON.stringify(tutorSettingData) !==
      JSON.stringify(prevProps.tutorSettingData)
    ) {
      let addressRaw = tutorSettingData?.tutorDetails?.addressRaw
        ? tutorSettingData.tutorDetails.addressRaw
        : "";
      let address = tutorSettingData?.address ? tutorSettingData.address : {};
      let canTeachOnline =
        tutorSettingData?.tutorDetails?.canTeachOnline !== ""
          ? tutorSettingData?.tutorDetails?.canTeachOnline
          : "";
      let tempValCanTeachOnline = canTeachOnline;
      
      let canTeachInperson =
      tutorSettingData?.tutorDetails?.canTeachInperson !== ""
      ? tutorSettingData?.tutorDetails?.canTeachInperson
      : "";
      let tempValCanTeachInperson = canTeachInperson;
      let modeOfTeaching =
        tutorSettingData?.tutorDetails?.modeOfTeaching !== ""
          ? tutorSettingData?.tutorDetails?.modeOfTeaching
          : "";

      this.setState({
        addressRaw,
        address,
        canTeachOnline,
        canTeachInperson,
        modeOfTeaching,
        tempValCanTeachOnline,
        tempValCanTeachInperson,
      });
    }
  };
  onSaveModeOfTutoring = () => {
    let {
      addressRaw,
      address,
      canTeachInperson,
      canTeachOnline,
      modeOfTeaching,
      willignessToTravel,
    } = this.state;
    let { tutorSettingData } = this.props;
    tutorSettingData = tutorSettingData ? tutorSettingData : {};
    tutorSettingData.tutorDetails = tutorSettingData.tutorDetails
      ? tutorSettingData.tutorDetails
      : {};
    tutorSettingData.tutorDetails.addressRaw = addressRaw;
    tutorSettingData.tutorDetails.address = address;
    tutorSettingData.tutorDetails.canTeachInperson = canTeachInperson;
    tutorSettingData.tutorDetails.canTeachOnline = canTeachOnline;
    tutorSettingData.tutorDetails.modeOfTeaching =
      canTeachOnline && canTeachInperson
        ? 2
        : canTeachOnline
        ? 0
        : canTeachInperson
        ? 1
        : "";
    tutorSettingData.tutorDetails.willignessToTravel = willignessToTravel;
    this.props.TutorSettingStoreData(tutorSettingData);
    this.setState({
      loader: true,
    });
    let updateTutorObj = { ...tutorSettingData };
    let tutorDetails = { ...updateTutorObj.tutorDetails };
    delete updateTutorObj.tutorDetails;
    updateTutorObj = { ...updateTutorObj, ...tutorDetails };
    let updateSettingParam = {
      updateSetting: {
        addressRaw: updateTutorObj.addressRaw,
        address: tutorSettingData?.address,
        canTeachInperson: updateTutorObj.canTeachInperson,
        canTeachOnline: updateTutorObj.canTeachOnline,
        modeOfTeaching: updateTutorObj.modeOfTeaching,
        willignessToTravel: updateTutorObj.willignessToTravel,
      },
    };
    updateTutorSettings(updateSettingParam)
      .then((res) => {
        this.setState({
          loader: false,
        });
        this.props.history.push("/tutor-dashboard/TutorSettingBioAndSub");
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loader: false,
        });
      });
  };

  onSaveAddress = () => {
    let { addressRaw, selectedIndex, address } = this.state;
    addressRaw = `${address.street} ${address.town} ${address.country} ${address.postCode}`;
    this.setState({
      selectMyaddress: "",
      addressRaw,
    });
  };

  render() {
    let {
      editMode,
      selectMyaddress,
      addAddress,
      selectedIndex,
      addressRaw,
      address,
      canTeachOnline,
      modeOfTeaching,
      willignessToTravel,
      tempValCanTeachOnline,
      canTeachInperson,
      tempValCanTeachInperson
    } = this.state;
    console.log("tempValCanTeachInperson",tempValCanTeachInperson)
    console.log("canTeachInperson",canTeachInperson)
    
    const onlineIpersonArr = [
      { head: "Online Lesson", desc: "I can teach online" },
      { head: "No Online Lesson", desc: "I can't teach online" },
    ];
    const onlineIpersonAddres = [
      {
        head: "In-person (My address only)",
      },
      {
        head: "I do not teach in-person",
      },
    ];
    return (
      <div className="flex-col-center">
        <EditHeadComponent
          settingTitle={"Mode of tutoring"}
          settingDescription={
            "Add your tutoring preference and the location of lessons."
          }
          isBorder={false}
          backToprofileView={() =>
            this.props.history.push("/tutor-dashboard/TutorSettingBioAndSub")
          }
          lg={9}
        />
        <Col
          lg={9}
          md={10}
          sm={12}
          xs={12}
          className="select-mode-of-setting-div"
        >
          {editMode === "online-inperson" ? (
            onlineIpersonArr.map((mode, index) => (
              <ModeOfTutoringPanel
                mode={mode}
                checkedValue={
                  mode.head === "Online Lesson"
                    ? canTeachOnline === true
                      ? true
                      : false
                    : canTeachOnline === false
                    ? true
                    : false
                }
                index={index}
                lastItem={onlineIpersonArr.length - 1 === index}
                onClose={() => {
                  this.setState({
                    canTeachOnline: tempValCanTeachOnline,
                    editMode: "",
                  });
                }}
                onSave={() => {
                  this.setState({
                    canTeachOnline,
                    tempValCanTeachOnline: canTeachOnline,
                    editMode: "",
                  });
                  this.onSaveModeOfTutoring();
                }}
                onRadioBtn={() =>
                  this.setState({
                    canTeachOnline:
                      mode.head === "Online Lesson" ? true : false,
                  })
                }
              />
            ))
          ) : (
            <div
              className="flex-between-center pointer"
              style={{
                padding: "14px 20px",
                minHeight: "70px",
              }}
              onClick={() =>
                this.setState({
                  editMode: "online-inperson",
                })
              }
            >
              <div>
                <div className="name-title-div">
                  {!canTeachOnline ? "No online" : "Online"}
                </div>
                <div className="value-title-div">
                  {!canTeachOnline
                    ? "I can't teach online"
                    : "I can teach online"}
                </div>
              </div>
              {/* <Image
                src={require("./../../../assets/icons/down-arrow.png")}
                className="pointer"
                style={{ width: "20px" }}
               
              /> */}
            </div>
          )}
        </Col>
        <Col
          lg={9}
          md={10}
          sm={12}
          xs={12}
          className="select-mode-of-setting-div"
        >
          {editMode === "online-inperson-address" ? (
            <div>
              <div
                className="flex-between-center"
                style={{
                  padding: "14px 20px",
                  minHeight: "70px",
                  borderBottom: "1px solid #ccc",
                }}
                // onClick={() =>
                //   this.setState({
                //     editMode: "online-inperson-address",
                //   })
                // }
              >
                <div>
                  <div className="name-title-div">
                    In-person (My address {addressRaw ? addressRaw : ""})
                  </div>
                  <div className="value-title-div">{willignessToTravel}</div>
                </div>
                {/* <Image
                src={require("./../../../assets/icons/down-arrow.png")}
                className="pointer"
                style={{ width: "20px" }}
               
              /> */}
                <Image
                  src={require("./../../../assets/icons/down-arrow.png")}
                  className="pointer"
                  style={{ width: "20px", transform: "rotate(180deg)" }}
                  onClick={() =>
                    this.setState({
                      canTeachInperson:tempValCanTeachInperson,
                      editMode: "",
                    })
                  }
                />
              </div>
              {onlineIpersonAddres.length &&
                onlineIpersonAddres.map((mode, index) => {
                  if (index !== 1) mode.desc = addressRaw;
                  return (
                    <ModeOfTutoringPanel
                      mode={mode}
                      index={index}
                      editMode={true}
                      lastItem={onlineIpersonAddres.length - 1 === index}
                      selectedIndex={selectedIndex}
                      addressRaw={addressRaw}
                      address={address}
                      modeOfTeaching={modeOfTeaching}
                      checkedValue={
                        mode.head === "I do not teach in-person"
                          ? canTeachInperson === false
                            ? true
                            : false
                          : canTeachInperson === true
                          ? true
                          : false
                      }
                      milesTxt={
                        index === 2 || index === 3
                          ? `Less than ${
                              willignessToTravel ? willignessToTravel : ""
                            } from `
                          : ""
                      }
                      onClick={() =>
                        this.setState({
                          selectMyaddress: mode.head,
                        })
                      }
                      onRadioBtn={() =>
                        this.setState({
                          selectedIndex: index,
                          canTeachInperson: index !== 1 ? true : false,
                          addAddress: {},
                        })
                      }
                      onSave={()=>{
                        this.setState({
                          tempValCanTeachInperson:canTeachInperson,
                          canTeachInperson,
                          editMode: "",
                        });
                        this.onSaveModeOfTutoring()
                      }}
                     
                    />
                  );
                })}
            </div>
          ) : (
            <div
              className="flex-between-center pointer"
              style={{
                padding: "14px 20px",
                minHeight: "70px",
              }}
              onClick={() =>
                this.setState({
                  editMode: "online-inperson-address",
                })
              }
            >
              {canTeachInperson ? (
                <div>
                  <div className="name-title-div">
                    In-person (My address {addressRaw ? addressRaw : ""})
                  </div>
                  <div className="value-title-div">{willignessToTravel}</div>
                </div>
              ) : (
                <div>
                  <div className="name-title-div">I do not teach in-person</div>
                </div>
              )}
              {/* <Image
                src={require("./../../../assets/icons/down-arrow.png")}
                className="pointer"
                style={{ width: "20px" }}
               
              /> */}
            </div>
          )}
        </Col>
        {/* <Col lg={9} md={10} sm={12} xs={12} style={{ padding: "0px" }}>
          <Button
            className="green-Button"
            style={{
              fontSize: "20px",
              fontWeight: "500",
              padding: "10px 30px",
              marginTop: "25px",
            }}
            onClick={this.onSaveModeOfTutoring}
          >
            Save
          </Button>
        </Col> */}
        <div style={{ marginBottom: "50px" }} />
        <EditTutorAddres
          Myaddress={selectMyaddress}
          selectedIndex={selectedIndex}
          isOpen={selectMyaddress ? true : false}
          onHide={() =>
            this.setState({
              selectMyaddress: "",
            })
          }
          onChange={(e) => {
            address = address ? address : {};
            address[e.target.name] = e.target.value;
            this.setState({
              address,
            });
          }}
          address={address}
          addAddress={addAddress}
          onSelect={(value) => {
            this.setState({
              addAddress: value,
            });
          }}
          onSaveAddress={this.onSaveAddress}
          willignessToTravel={{ name: willignessToTravel }}
          onSelectWilliamTotravel={(value) => {
            this.setState({
              willignessToTravel: value.name,
            });
          }}
        />
      </div>
    );
  }
}

const EditTutorAddres = ({
  isOpen,
  onHide,
  Myaddress,
  onChange,
  address,
  onSelect,
  addAddress,
  selectedIndex,
  onSaveAddress,
  willignessToTravel,
  onSelectWilliamTotravel,
}) => {
  return (
    <div>
      <Modal
        size="lg"
        className="ProfileStatus-modal"
        show={isOpen}
        onHide={onHide}
      >
        <Modal.Body>
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ padding: "10px 40px", textAlign: "justify" }}
            >
              <div
                className="cancel-btn flex-center-center"
                onClick={onHide}
                style={{
                  fontSize: "17px",
                  width: "30px",
                  height: "30px",
                  marginTop: "20px",
                }}
              >
                <i className="mdi mdi-close"></i>
              </div>
              <div style={{ marginBottom: "50px" }} />
              <h4 style={{ color: "#000" }}>{Myaddress}</h4>
              <CommonDropdown
                dropdownTitle={"What is your address?"}
                style={{ headTitleStyle: { fontSize: "17px" } }}
                itemArray={[{ name: "Add new address", image: messageImg }]}
                value={addAddress}
                onSelect={(value) => onSelect(value)}
                // disabled={selectedIndex === 3 ? true : false}
              />
              <div style={{ marginBottom: "20px" }} />
              <div>
                Other members of Askademia will not see this address. This
                address will only provide to parents or students once you have
                accepted their lesson.
              </div>
              <div style={{ marginBottom: "20px" }} />
              {addAddress.name ? (
                <Col
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className="flex-start-center"
                  style={{ flexDirection: "column", padding: "0px" }}
                >
                  <InputComp
                    value={address?.street}
                    onChange={onChange}
                    placeholder="Street"
                    name={"street"}
                    style={{
                      fontSize: "19px",
                    }}
                  />
                  <InputComp
                    value={address?.town}
                    name={"town"}
                    placeholder="Town"
                    onChange={onChange}
                    style={{
                      fontSize: "19px",
                    }}
                  />
                  <Row style={{ margin: "0px", width: "100%" }}>
                    <Col
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="flex-between-center"
                      style={{ paddingLeft: "0px" }}
                    >
                      <InputComp
                        value={address?.country}
                        name={"country"}
                        placeholder="Country"
                        onChange={onChange}
                        style={{
                          fontSize: "19px",
                        }}
                      />
                    </Col>
                    <Col
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="flex-between-center"
                      style={{ paddingRight: "0px" }}
                    >
                      <InputComp
                        value={address?.postCode}
                        name={"postCode"}
                        placeholder="Postcode"
                        onChange={onChange}
                        style={{
                          fontSize: "19px",
                          headTitle: {
                            fontSize: "34px",
                            fontWeight: "500",
                          },
                        }}
                      />
                    </Col>
                  </Row>
                  <InputComp
                    InputHeadTitle={"Country / region"}
                    value={"United Kingdom"}
                    disabled={true}
                    image={require("./../../../assets/icons/lock.png")}
                    style={{
                      fontSize: "19px",
                      imageheight: "17px",
                      headTitle: {
                        fontSize: "19px",
                      },
                    }}
                  />
                </Col>
              ) : null}

              <CommonDropdown
                dropdownTitle={
                  "How far you will travel from your address to teach the student?"
                }
                style={{ headTitleStyle: { fontSize: "17px" } }}
                // disabled={selectedIndex === 0 ? true : false}
                dropdowndefaultValue={"I only teach at my address"}
                itemArray={[
                  { name: "I only teach at my address" },
                  { name: "1 miles" },
                  { name: "2 miles" },
                  { name: "10 miles" },
                  { name: "15 miles" },
                  { name: "20 miles" },
                ]}
                value={willignessToTravel}
                onSelect={onSelectWilliamTotravel}
              />
              <Button
                className="green-Button"
                style={{
                  fontSize: "20px",
                  fontWeight: "500",
                  padding: "10px 30px",
                  marginTop: "25px",
                }}
                onClick={onSaveAddress}
              >
                Save
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const ModeOfTutoringPanel = ({
  mode,
  index,
  onClose,
  lastItem,
  onClick,
  editMode,
  onRadioBtn,
  selectedIndex,
  checkedValue,
  milesTxt,
  onSave,
  addressRaw,
  onlinePanel,
}) => {
  return (
    <div
      className="flex-between-center"
      style={{
        borderBottom: !lastItem ? "1px solid #ccc" : "",
        padding: "10px 20px",
        minHeight: "70px",
        // background: index !== 1 && selectedIndex === 1 ? "#efeded" : "",
        // cursor: index !== 1 && selectedIndex === 1 ? "not-allowed" : "",
      }}
    >
      <div>
        {/* <div className="custom-control custom-checkbox">
          <input
            type="checkbox"
            className="custom-control-input"
            id={`defaultUnchecked${index}`}
          ></input>
          <label
            className="custom-control-label name-title-div"
            for={`defaultUnchecked${index}`}
          >
            <span style={{ marginLeft: "10px" }}> {mode.head}</span>
          </label>
        </div> */}
        <div className="custom-control custom-radio custom-control-inline custom-control-right ">
          <input
            type="radio"
            id={`customRadioInline${index}`}
            name="customRadioInline0"
            className="custom-control-input"
            checked={checkedValue}
          />
          <label
            className="custom-control-label name-title-div pointer"
            htmlFor={`customRadioInline${index}`}
            onClick={onRadioBtn}
          >
            {mode.head}
          </label>
        </div>

        {mode.desc ? (
          <div className="value-title-div" style={{ marginLeft: "34px" }}>
            {`${milesTxt ? milesTxt : ""} ${mode.desc}`}
            {(selectedIndex === index || checkedValue) && editMode ? (
              <span
                className="green-txt edit-btn"
                style={{ marginLeft: "5px" }}
                onClick={onClick}
              >
                . Edit
              </span>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </div>
      {checkedValue ? (
        <div
          className="value-title-div flex-end-center"
          style={{ flex: 1, marginRight: lastItem ? "50px" : "30px" }}
        >
          <span
            className="green-txt edit-btn"
            style={{ marginLeft: "5px" }}
            onClick={onSave}
          >
            Save
          </span>
        </div>
      ) : (
        ""
      )}

      {!addressRaw && index === 0 ? (
        <Image
          src={require("./../../../assets/icons/down-arrow.png")}
          className="pointer"
          style={{ width: "20px", transform: "rotate(180deg)" }}
          onClick={onClose}
        />
      ) : (
        ""
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    TutorSettingReducer: { tutorSettingData },
  } = state;

  return {
    tutorSettingData,
  };
};
const mapDispatchToprops = (dispatch) => {
  return {
    TutorSettingStoreData: (payload) =>
      dispatch(TutorSettingAction.TutorSettingStoreData(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(ModeofTutorSetting);
